import {
  Delete,
  Edit,
  Favorite,
  FavoriteBorderRounded,
  FavoriteOutlined,
} from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import {
  Box,
  Card,
  CardContent,
  IconButton,
  TextField,
  Tooltip,
} from "@mui/material";
import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { TAnalyticView } from "../../shared/types/analyticView.type";
import { debounce, isEmpty } from "lodash";
import { useAuth } from "../../hooks/useAuth";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { Icon } from "@iconify/react";

type ConfigActionProps = {
  view: string;
  updateName: (name: string) => void;
};

function ConfigAction({ view, updateName }: ConfigActionProps) {
  const debouncedChange = debounce((value: string) => {
    updateName(value);
  }, 400);

  return (
    <Box
      sx={{
        display: "flex",
        gap: 2,
        alignItems: "center",
        flexDirection: "column",
        width: "100%",
      }}
    >
      <Card sx={{ width: "100%" }}>
        <CardContent
          sx={{
            display: "flex",
            gap: 2,
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <TextField
            fullWidth
            defaultValue={view}
            onChange={(e) => debouncedChange(e.target.value)}
            size="small"
            label={t("configuration")}
          ></TextField>
        </CardContent>
      </Card>
    </Box>
  );
}

export default ConfigAction;
